/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/BoxFooter.scss';

class BoxFooter extends React.Component {
  render() {
    return (
      <footer className={cx('BoxFooter', this.props.className)}>
        {this.props.children}
      </footer>
    );
  }
}

export default BoxFooter;



// WEBPACK FOOTER //
// ./src/components/BoxFooter.jsx